<template>


  <b-card border-variant="light" class="my-2">

    <b-row class="my-1">
      <b-col>
        <h5>Dolor</h5>
      </b-col>
    </b-row>

    <b-row align-v="center" class="ml-1">
      <b-col class="col-2">
        <div>Lugar:</div>
      </b-col>

      <b-col>
        <v-select
          placeholder="Seleccione una o mas opciones"
          :options="lugarOpts"
          :reduce="option => option"
          label="text"
          :multiple="true"
          taggable
          @input="newArray => dolor.lugar = onAddNewOpt(newArray)"
        />
      </b-col>
    </b-row>


    <b-row align-v="center" class="ml-1 my-1">
      <b-col class="col-2">
        <div>Tipo:</div>
      </b-col>

      <b-col>
        <v-select
          placeholder="Seleccione una o mas opciones"
          :options="tipoOpts"
          :reduce="option => option"
          label="text"
          :multiple="true"
          taggable
          @input="newArray => dolor.tipo = onAddNewOpt(newArray)"
        />
      </b-col>
    </b-row>

    <b-row align-v="center" class="ml-1 my-1">
      <b-col class="col-3">
        <div>Intensidad:</div>
      </b-col>

      <b-col>
        <v-select
          placeholder="Seleccione una o mas opciones"
          :options="intensidadOpts"
          :reduce="option => option"
          label="text"
          v-model="dolor.intensidad"
        />
      </b-col>
    </b-row>

    <b-row align-v="center" class="ml-1 my-1">
      <b-col class="col-3">
        <div>Irradiación:</div>
      </b-col>

      <b-col class="col-2">
        <b-form-checkbox 
          switch 
          v-model="dolor.irradiacion.active"
        >
          <span class="score">
            {{ dolor.irradiacion.active ? 'Si' : 'No' }}
          </span>
        </b-form-checkbox>
      </b-col>


      <b-col v-if="dolor.irradiacion.active">
        <b-form-input
          v-model="dolor.irradiacion.descripcion"
          placeholder="Ingrese la descripción"
        />
      </b-col>
    </b-row>


    <b-row align-v="center" class="ml-1 my-1">
      <b-col class="col-3">
        <div>Desencadenante:</div>
      </b-col>

      <b-col>
        <v-select
          placeholder="Seleccione una o mas opciones"
          :options="desencadenantesOpts"
          :reduce="option => option"
          label="text"
          :multiple="true"
          taggable
          @input="newArray => dolor.desencadenantes.items = onAddNewOpt(newArray)"

        />

      </b-col>

      <b-col 
        v-if="dolor.desencadenantes.items.some(d => d.value === 'ingestiva')"
        class="d-flex col-12 ml-1 align-items-center my-1"
      >
        <label for="" class="col-3">Tipo de alimentos</label>
        <b-form-input
          v-model="dolor.desencadenantes.alimentos"
          placeholder="Ingrese una descripcion"
        />
      </b-col>
    </b-row>

    <b-row align-v="center" class="ml-1 my-1">
      <b-col class="col-3">
        <div>Con que lo alivia:</div>
      </b-col>

      <b-col>
        <v-select
          placeholder="Seleccione una o mas opciones"
          :options="alivioOpts"
          :reduce="option => option"
          label="text"
          :multiple="true"
          taggable
          @input="newArray => dolor.alivio.items = onAddNewOpt(newArray)"

        />

      </b-col>

      <b-col 
        v-if="dolor.alivio.items.some(d => d.value === 'medicacion')"
        class="d-flex col-12 ml-1 align-items-center my-1"
      >
        <label for="" class="col-3">Tipo de medicacion</label>
        <b-form-input
          v-model="dolor.alivio.medicacion"
          placeholder="Ingrese una descripcion"
        />
      </b-col>
    </b-row>

  </b-card>
  
</template>

<script>

import vSelect from "vue-select";
import { addNewOpt } from '@/shared/helpers';

export default {
  name: "SintomasDolor",

  components: {
    vSelect
  },


  data() {
    return{

      dolor: {
        lugar: [],
        tipo : [],
        desencadenantes: {
          items:[],
          alimentos:''
        },
        alivio: {
          items:[],
          medicacion:''
        },
        intensidad: null,
        irradiacion: {
          active: false,
          descripcion: ''
        }
      },

      lugarOpts: [
        { value: "pecho",                 text: "Pecho" },
        { value: "epigastrio",            text: "Epigastrio" },
        { value: "mesogastrio",           text: "Mesogastrio" },
        { value: "hipocondrio_derecho",   text: "Hipocondrio derecho" },
        { value: "hipocondrio_izquierdo", text: "Hipocondrio izquierdo" },
        { value: "flanco_derecho",        text: "Flanco derecho" },
        { value: "flanco_izquierdo",      text: "Flanco izquierdo" },
        { value: "hipogastrio",           text: "Hipogastrio" },
        { value: "todo_el_abdomen",       text: "Todo el abdomen" },
      ],

      tipoOpts: [
        { value: "urente",   text: "Urente" },
        { value: "punzante", text: "Punzante" },
        { value: "sordo",    text: "Sordo" },
        { value: "continuo", text: "Continuo" },
        { value: "colico",   text: "Colico" },
      ],

      intensidadOpts: [
        { value: "leve",     text: "Leve" },
        { value: "moderada", text: "moderada" },
        { value: "severa",   text: "Severa" },
      ],

      desencadenantesOpts: [
        { value: "ingestiva", text: "Ingestiva" },
        { value: "actividad", text: "Actividad" },
        { value: "estres",    text: "Estres" },
        { value: "sin_causa_aparente", text: "Sin causa aparente" },
      ],

      alivioOpts: [
        { value: "medicacion", text: "Medicación" },
        { value: "alimentos",  text: "Alimentos" },
        { value: "pasa_solo",  text: "Pasa solo" },
      ],
    }
  },

  methods: {

    onAddNewOpt( newValue ){
      return addNewOpt( newValue );
    }

  },

  watch: {
    dolor: {
      deep: true,
      handler(newValue){
        this.$store.commit("setGastro", { dolor:newValue });
      }
    }
  }
}
</script>